<template>
  <div class="ba-grid ba-gp-1" v-if="!is_bundle">
    <div v-if="!is_concessionaire" class="ba-card ba6-plan-data">
      <div class="ba6-left-plan-data ba-flex ba-gp-1 ba-f-column ba-h-100">
        <div class="ba-grid ba-gp-1 ba-ai-start ba-h-50">
            <span class="ba6-info-subtitle" v-text="t.label_plan"></span>
            <span class="ba6-info-title" v-text="accountInfo.plan"></span>
            <!-- Plan resources -->
            <span v-if="!hasErrorToGetMbDataFromDate && resourceIsActive(0) && usageData.resources[0]" class="ba6-info-subtitle">{{ usageData.resources[0]['limit'] }} {{ t.subscribers_plan }}</span>
            <span v-if="!hasErrorToGetMbDataFromDate && resourceIsActive(1) && usageData.resources[1]" class="ba6-info-subtitle">{{ usageData.resources[1]['limit'] }} {{ t.label_emails }}</span>
            <span v-if="!hasErrorToGetMbDataFromDate && resourceIsActive(2) && usageData.resources[2]" class="ba6-info-subtitle">{{ usageData.resources[2]['limit'] }} {{ t.profissional_email_accounts }}</span>
            <span v-if="!hasErrorToGetMbDataFromDate && resourceIsActive(3) && usageData.resources[3]" class="ba6-info-subtitle">{{ (usageData.resources[3].percentage == 'UNLIMITED' ? t.sc_sales_fee.replace(':fee%', t.not_applied) : t.sc_sales_fee.replace(':fee', usageData.resources[3].percentage)) }}</span>

        </div>
        <div class="ba-flex ba-gp-1 ba-ai-end ba-h-50">
          <a href="https://checkout.builderall.com/plans" target="_blank" class="ba-btn ba-md ba-blue ba-w-100" v-text="t.change_my_plan"></a>
        </div>
      </div>
      <hr v-if="!hasErrorToGetMbDataFromDate || loadingMbDataFromLastPaymentDate" class='ba-hr-column'>
      <builderall-loader v-if="!hasErrorToGetMbDataFromDate || loadingMbDataFromLastPaymentDate" class="ba-w-100" :loading="loadingMbDataFromLastPaymentDate">
        <div class="ba-grid ba-gp-1 ba-pd-y-1">
          <div class="ba-flex ba-gp-1 ba-ai-center ba-jc-sb">
            <span class="ba6-info-subtitle" v-text="t.package_price"></span>
            <strong v-if="usageData.billing_amount.amount_charged && usageData.billing_amount.currency_charged" class="ba6-payment-amount">{{ `${usageData.billing_amount.currency_charged} ${usageData.billing_amount.amount_charged}`}} = {{ usageData.currency}} {{ usageData.billing_amount.amount }}</strong>
            <strong v-else class="ba6-payment-amount">{{ usageData.currency}} {{ usageData.billing_amount.amount }}</strong>
          </div>
          <span class="ba6-info-subtitle ba6-subtitle-tooltip">
            {{ t.usage }} <builderall-icon
                    ba-tooltip-position='bottom'
                    :ba-tooltip-title="t.displayed_usage_calculated_from + ' ' + usageData.last_payment"
                    ba-tooltip-color='dark'
                    code='help'
                  ></builderall-icon>
          </span>
          <!-- Resource 0 -->
          <div class="ba6-box-progress-amount" v-if="resourceIsActive(0)">
            <a class='ba-progress'>
                <span class='ba-progress-title' v-text="t.subscribers_plan"></span>
                <progress
                  :class="{'ba-progress-bar': true, 'ba-limit-alert': showAlertLimit(usageData.resources[0])}"
                  :value="!usageData.resources[0]['limit'] ? usageData.resources[0]['usage'] : usageData.resources[0]['usage'] > usageData.resources[0]['limit'] ? usageData.resources[0]['limit'] : usageData.resources[0]['usage']"
                  :max="!usageData.resources[0]['limit'] ? null : usageData.resources[0]['limit'] > usageData.resources[0]['usage'] ? usageData.resources[0]['limit'] : usageData.resources[0]['usage']"
                ></progress>
                <div class='ba-progress-details'>
                    <span class='ba-progress-data' v-text="getProgressBillingData(usageData.resources[0])"></span>
                </div>
            </a>
            <span class="ba6-info-amount" v-if="!usageData.resources[0].amount" v-text="t.label_included"></span>
            <span class="ba6-info-amount" v-else>{{ usageData.resources[0].currency }} {{ parseFloat(usageData.resources[0].amount).toFixed(2) }}</span>
          </div>
          <!-- Resource 1 -->
          <div class="ba6-box-progress-amount" v-if="resourceIsActive(1)">
            <a class='ba-progress'>
                <span class='ba-progress-title' v-text="t.email_sent"></span>
                <progress
                  :class="{'ba-progress-bar': true, 'ba-limit-alert': showAlertLimit(usageData.resources[1])}"
                  :value="!usageData.resources[1]['limit'] ? usageData.resources[1]['usage'] : usageData.resources[1]['usage'] > usageData.resources[1]['limit'] ? usageData.resources[1]['limit'] : usageData.resources[1]['usage']"
                  :max="!usageData.resources[1]['limit'] ? null : usageData.resources[1]['limit'] > usageData.resources[1]['usage'] ? usageData.resources[1]['limit'] : usageData.resources[1]['usage']"
                ></progress>
                <div class='ba-progress-details'>
                  <span class='ba-progress-data' v-text="getProgressBillingData(usageData.resources[1])"></span>
                </div>
            </a>
            <span class="ba6-info-amount" v-if="!usageData.resources[1].amount" v-text="t.label_included"></span>
            <span class="ba6-info-amount" v-else>{{ usageData.resources[1].currency }} {{ parseFloat(usageData.resources[1].amount).toFixed(2) }}</span>
          </div>
          <!-- Resource 2 -->
          <div class="ba6-box-progress-amount" v-if="resourceIsActive(2)">
            <a class='ba-progress'>
                <span class='ba-progress-title'>{{ t.profissional_email_accounts }}</span>
                <progress
                  :class="{'ba-progress-bar': true, 'ba-limit-alert': showAlertLimit(usageData.resources[2])}"
                  :value="!usageData.resources[2]['limit'] ? usageData.resources[2]['usage'] : usageData.resources[2]['usage'] > usageData.resources[2]['limit'] ? usageData.resources[2]['limit'] : usageData.resources[2]['usage']"
                  :max="!usageData.resources[2]['limit'] ? null : usageData.resources[2]['limit'] > usageData.resources[2]['usage'] ? usageData.resources[2]['limit'] : usageData.resources[2]['usage']"
                ></progress>
                <div class='ba-progress-details'>
                  <span class='ba-progress-data' v-text="getProgressBillingData(usageData.resources[2])"></span>
                </div>
            </a>
            <span class="ba6-info-amount" v-if="!usageData.resources[2].amount" v-text="t.label_included"></span>
            <span class="ba6-info-amount" v-else>{{ usageData.resources[2].currency }} {{ parseFloat(usageData.resources[2].amount).toFixed(2) }}</span>
          </div>
          <!-- Resource 3 -->
          <div class="ba6-box-progress-amount" v-if="resourceIsActive(3)">
            <a class='ba-progress ba-pd-t-1'>
              <span class='ba-progress-title'>{{ (usageData.resources[3].percentage == 'UNLIMITED'
                  ? t.sc_sales_fee_data.replace(':fee%', t.not_applied).replace(':currency', usageData.resources[3].currency).replace(':base_value', parseFloat(usageData.resources[3].usage ).toFixed (2))
                  : t.sc_sales_fee_data.replace(':fee', usageData.resources[3].percentage).replace(':currency', usageData.resources[3].currency).replace(':base_value', parseFloat(usageData.resources[3].usage ).toFixed (2)))}}</span>
            </a>
            <span class="ba6-info-amount" v-if="!usageData.resources[3].amount" v-text="t.label_included"></span>
            <span class="ba6-info-amount" v-else>{{ usageData.resources[3].currency }} {{ parseFloat(usageData.resources[3].amount).toFixed(2) }}</span>
          </div>
          <br>
          <hr class="ba-hr-row">
          <div class="ba-flex ba-gp-1 ba-ai-center ba-jc-sb">
            <div class="ba-grid">
              <span class="ba6-info-subtitle" v-text="t.estimated_bill"></span>
              <span class="ba6-payment-data">{{ t.next_payment_on }} {{ accountInfo.user_data.pag_validade }}</span>
            </div>
            <span class="ba6-payment-total-amount">{{ usageData.currency}} {{ (parseFloat(usageData.billing_amount.amount) + parseFloat(usageData.amount)).toFixed(2) }}</span>
          </div>
        </div>
      </builderall-loader>
    </div>
    <div class="quotas-two-elements">
      <builderall-loader class="ba-w-100" :loading="loadingWbData">
        <div class="ba-card ba-h-100">
          <div class='ba6-card-top ba-flex ba-gp-1 ba-ai-center ba-w-100'>
              <span class="ba6-main-icon ba-bg-orange1">
                  <svg width="18" height="17" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_893_14770)">
                      <g opacity="0.22">
                      <path d="M9.41126 6.65895C9.33228 6.65895 9.25444 6.61728 9.21383 6.54294C9.15291 6.43369 9.19352 6.29741 9.30182 6.23658L9.32664 6.22307C9.4372 6.1645 9.57371 6.2073 9.63125 6.31655C9.68991 6.42693 9.64704 6.56322 9.53761 6.62066L9.51956 6.62967C9.48459 6.64882 9.44736 6.65783 9.41013 6.65783L9.41126 6.65895Z" fill="#575FAA"/>
                      <path d="M2.53292 12.6667C2.45733 12.6667 2.38513 12.6284 2.34339 12.5631C2.29375 12.4854 2.29601 12.3851 2.34903 12.3096C3.24817 11.0549 2.7766 9.38799 2.54646 8.75951C2.07827 9.00955 1.36867 9.06587 1.2739 9.07263C1.19042 9.07938 1.10919 9.03658 1.06632 8.96563C1.02233 8.89354 1.02233 8.80344 1.06632 8.73135C1.48938 8.02966 1.95305 6.19715 2.14484 5.39071C1.79624 5.50447 1.35513 5.64413 1.32805 5.65314C1.24232 5.68017 1.14868 5.65314 1.09001 5.58669C1.03135 5.52024 1.01781 5.42337 1.05617 5.34228L2.11325 3.10205C2.14822 3.02771 2.22042 2.97815 2.30278 2.97365C2.42913 2.96576 2.52389 2.96126 2.61076 2.96126C2.95034 2.96126 3.33052 3.0401 3.73214 3.12232C4.26802 3.2327 4.82307 3.34758 5.30253 3.27888C5.71656 3.22031 5.97152 3.07276 6.29756 2.82272C6.39684 2.74726 6.53785 2.76528 6.61344 2.86439C6.68903 2.96351 6.67098 3.1043 6.5717 3.17976C6.20279 3.46247 5.87337 3.65169 5.36571 3.7249C4.8084 3.80486 4.21499 3.6821 3.64076 3.56271C3.2617 3.48499 2.90295 3.41066 2.61076 3.41066C2.56564 3.41066 2.51825 3.41178 2.4641 3.41403L1.68568 5.06408C1.96546 4.97398 2.27909 4.87261 2.37723 4.83544C2.45395 4.80616 2.54194 4.82192 2.60399 4.87599C2.66604 4.93005 2.69425 5.0134 2.67732 5.09449C2.65476 5.19924 2.17078 7.39555 1.65409 8.56916C1.98577 8.50947 2.34677 8.40472 2.48667 8.2538C2.53743 8.19973 2.61189 8.17383 2.68635 8.18509C2.76081 8.19636 2.82398 8.24366 2.85557 8.31124C2.89844 8.40247 3.81901 10.396 2.99546 12.1024C4.16874 11.7949 5.44806 11.136 6.07193 9.30915C6.10013 9.22806 6.17121 9.16949 6.25582 9.15823C6.32125 9.15034 6.38555 9.17061 6.43406 9.21229C6.65744 8.96563 7.0207 8.56128 7.18541 8.35517C7.24069 8.28646 7.32982 8.25718 7.4133 8.27632C7.67729 7.96208 8.10711 7.43609 8.31018 7.11172C8.60801 6.63641 9.14614 6.31767 9.30408 6.23207C9.41351 6.17237 9.55002 6.21292 9.60981 6.32217C9.6696 6.43142 9.62899 6.56771 9.51956 6.6274C9.42479 6.67921 8.93743 6.95741 8.69149 7.35049C8.36884 7.86522 7.56447 8.7933 7.53063 8.83272C7.47535 8.8958 7.38961 8.92283 7.30951 8.90481C7.00717 9.25284 6.59877 9.69885 6.57621 9.72251C6.52883 9.77319 6.46114 9.80022 6.39232 9.79459C6.38443 9.79459 6.37653 9.79347 6.36863 9.79121C5.51688 11.8512 3.81111 12.4133 2.57579 12.6566C2.56112 12.6599 2.54646 12.6611 2.53179 12.6611L2.53292 12.6667Z" fill="#575FAA"/>
                      <path d="M9.51393 6.95515C9.50717 6.95515 9.5004 6.95515 9.49363 6.95515C9.39435 6.94614 9.31312 6.87293 9.29282 6.77494L9.22964 6.45844C9.20482 6.3368 9.28492 6.21741 9.40676 6.19376C9.4643 6.1825 9.5207 6.19376 9.56696 6.22192C9.6087 6.17687 9.65495 6.13519 9.70572 6.1014C9.87381 5.98877 10.2687 5.72634 10.9568 5.87952C11.0888 5.9088 11.2242 5.94147 11.3573 5.973C11.7183 6.05973 12.1685 6.16898 12.3095 6.13294C12.4178 6.10591 12.7653 5.97526 12.71 5.42562C12.7032 5.35241 12.7314 5.28032 12.7878 5.23189C12.9345 5.10574 13.1488 4.87034 13.2086 4.70478C13.1703 4.59665 12.9875 4.20582 12.2373 3.69109C12.1572 3.63591 12.1211 3.53679 12.1482 3.44331C12.1482 3.44105 12.2407 3.09302 12.0511 2.80807C11.8244 2.46905 11.1599 1.98586 10.6816 1.74595C10.6049 1.70766 10.5563 1.62994 10.5563 1.54434V1.06566C10.2856 1.13324 9.84448 1.26614 9.43271 1.49028C9.40676 1.5038 9.37856 1.51281 9.34923 1.51619C9.34584 1.51619 8.80207 1.5939 7.73935 2.30235C7.55321 2.42625 7.37158 2.55577 7.18543 2.69881C7.08615 2.77428 6.94514 2.75626 6.86955 2.65714C6.79396 2.55802 6.81201 2.41724 6.91129 2.34177C7.10533 2.19197 7.29486 2.05682 7.49003 1.92729C8.48957 1.26164 9.08185 1.10959 9.25108 1.07692C9.96294 0.697357 10.7132 0.570084 10.7447 0.564452C10.8102 0.553189 10.8767 0.572336 10.9275 0.615136C10.9783 0.657936 11.0076 0.72101 11.0076 0.787462V1.41031C11.5299 1.69414 12.1685 2.17395 12.4268 2.56028C12.6344 2.87001 12.6355 3.21016 12.613 3.40614C13.5674 4.09657 13.6588 4.62143 13.6667 4.68112C13.67 4.70478 13.6689 4.72956 13.6644 4.75321C13.6046 5.04943 13.3181 5.35578 13.168 5.4977C13.1861 6.14533 12.7856 6.47984 12.4212 6.57108C12.1719 6.63302 11.7465 6.53053 11.2535 6.41114C11.1227 6.3796 10.9907 6.34807 10.8609 6.31878C10.4007 6.21629 10.1536 6.34581 9.95843 6.47647C9.86028 6.54179 9.75762 6.73664 9.72603 6.81549C9.69105 6.90108 9.6087 6.9574 9.51619 6.9574L9.51393 6.95515Z" fill="#575FAA"/>
                      </g>
                      <path d="M9.24544 6.49904C9.16535 6.49904 9.08863 6.45624 9.04689 6.3819C8.9871 6.27265 9.02771 6.13637 9.13714 6.07667L9.16083 6.06316C9.27139 6.00459 9.4079 6.04739 9.46543 6.15664C9.5241 6.26702 9.48123 6.4033 9.3718 6.46074L9.35262 6.47088C9.31878 6.49003 9.28155 6.49791 9.24432 6.49791L9.24544 6.49904Z" fill="white"/>
                      <path d="M2.36712 12.5068C2.29154 12.5068 2.21933 12.4685 2.17759 12.4032C2.12795 12.3254 2.13021 12.2252 2.18323 12.1497C3.08463 10.8916 2.61193 9.22696 2.38066 8.5996C1.91248 8.84964 1.20287 8.90596 1.10698 8.91271C1.02349 8.91835 0.942268 8.8778 0.899398 8.80571C0.856528 8.73363 0.8554 8.64353 0.899398 8.57144C1.32245 7.86975 1.78612 6.03724 1.97791 5.2308C1.62931 5.34456 1.1882 5.48422 1.16113 5.49323C1.07539 5.52026 0.982881 5.49323 0.923089 5.42678C0.864425 5.3592 0.850888 5.26346 0.889245 5.18237L1.94632 2.94213C1.98129 2.8678 2.0535 2.81824 2.13585 2.81373C2.2622 2.80585 2.35697 2.80134 2.44496 2.80134C2.78454 2.80134 3.16473 2.88019 3.56635 2.96241C4.10222 3.07279 4.65727 3.18767 5.13673 3.11896C5.54964 3.0604 5.80573 2.91285 6.13176 2.66281C6.23104 2.58735 6.37206 2.60537 6.44764 2.70448C6.52323 2.8036 6.50518 2.94439 6.4059 3.01985C6.037 3.30255 5.70758 3.49177 5.19991 3.56498C4.6426 3.64383 4.0492 3.52218 3.47497 3.4028C3.09591 3.32508 2.73716 3.25074 2.44496 3.25074C2.39984 3.25074 2.35246 3.25187 2.29831 3.25412L1.51988 4.90417C1.79966 4.81406 2.11329 4.7127 2.21031 4.67553C2.28702 4.64624 2.37502 4.66201 2.43707 4.71607C2.49912 4.77014 2.52732 4.85348 2.5104 4.93458C2.48783 5.03933 2.00386 7.23564 1.48716 8.40925C1.81884 8.34956 2.17985 8.24481 2.31974 8.09388C2.37051 8.03982 2.44496 8.01392 2.51942 8.02518C2.59388 8.03644 2.65706 8.08375 2.68865 8.15133C2.73152 8.24256 3.65209 10.2361 2.82854 11.9425C4.00294 11.635 5.28114 10.9761 5.905 9.14924C5.93321 9.06815 6.00428 9.00958 6.08889 8.99831C6.15433 8.99043 6.21863 9.0107 6.26714 9.05238C6.49051 8.80571 6.85378 8.40137 7.01849 8.19525C7.07377 8.12655 7.16289 8.09726 7.24638 8.11641C7.51036 7.80217 7.94019 7.27618 8.14326 6.9518C8.44109 6.4765 8.97921 6.15775 9.13716 6.07215C9.24659 6.01246 9.38309 6.05301 9.44288 6.16226C9.50268 6.27151 9.46206 6.4078 9.35263 6.46749C9.25787 6.5193 8.77051 6.7975 8.52457 7.19058C8.20192 7.70531 7.39755 8.63339 7.3637 8.67281C7.30842 8.73588 7.22268 8.76291 7.14259 8.74489C6.84024 9.09292 6.43185 9.53894 6.40929 9.5626C6.36191 9.61328 6.29422 9.64031 6.2254 9.63468C6.2175 9.63468 6.2096 9.63355 6.20171 9.6313C5.34995 11.6913 3.64419 12.2534 2.40886 12.4966C2.3942 12.5 2.37953 12.5011 2.36487 12.5011L2.36712 12.5068Z" fill="white"/>
                      <path d="M9.34697 6.79408C9.3402 6.79408 9.33343 6.79408 9.32554 6.79408C9.22626 6.78507 9.14503 6.71185 9.12473 6.61387L9.06155 6.29737C9.03673 6.17573 9.11683 6.05634 9.23867 6.03269C9.29621 6.02143 9.35261 6.03269 9.39887 6.06085C9.44061 6.01579 9.48686 5.97412 9.53763 5.94033C9.70572 5.8277 10.1006 5.56527 10.7887 5.71845C10.9207 5.74773 11.0561 5.78039 11.1892 5.81193C11.5503 5.89866 12.0004 6.00791 12.1414 5.97187C12.2497 5.94484 12.5972 5.81418 12.5419 5.26454C12.5351 5.19133 12.5633 5.11925 12.6197 5.07082C12.7664 4.94467 12.9807 4.70927 13.0405 4.5437C13.0022 4.43558 12.8194 4.04475 12.0692 3.53002C11.9891 3.47483 11.953 3.37572 11.9801 3.28223C11.9801 3.27998 12.0726 2.93195 11.8831 2.64699C11.6563 2.30797 10.9918 1.82479 10.5135 1.58488C10.4368 1.54659 10.3883 1.46887 10.3883 1.38327V0.904589C10.1175 0.972168 9.67639 1.10507 9.26462 1.32808C9.23867 1.3416 9.21047 1.35061 9.18113 1.35399C9.17775 1.35399 8.63398 1.4317 7.57126 2.14015C7.38625 2.26292 7.20461 2.39357 7.01734 2.53774C6.91806 2.6132 6.77704 2.59518 6.70146 2.49607C6.62587 2.39695 6.64392 2.25616 6.7432 2.1807C6.9395 2.0309 7.1279 1.89462 7.32194 1.76622C8.32148 1.10057 8.91376 0.948515 9.08298 0.915852C9.79485 0.536285 10.5451 0.409012 10.5767 0.40338C10.6421 0.392117 10.7087 0.411265 10.7594 0.454065C10.8102 0.496864 10.8395 0.559938 10.8395 0.62639V1.24924C11.3618 1.53307 12.0015 2.01288 12.2587 2.39921C12.4663 2.70894 12.4674 3.04909 12.4449 3.24507C13.3993 3.9355 13.4907 4.46036 13.4986 4.52005C13.502 4.5437 13.5008 4.56848 13.4963 4.59214C13.4365 4.88836 13.1488 5.19471 12.9999 5.33663C13.018 5.98426 12.6175 6.31877 12.2531 6.41C12.0038 6.47195 11.5785 6.36946 11.0855 6.25007C10.9546 6.21853 10.8226 6.18699 10.6929 6.15771C10.2314 6.05521 9.98438 6.18587 9.79033 6.31539C9.69219 6.38072 9.59178 6.57219 9.55794 6.65441C9.52296 6.74001 9.43948 6.7952 9.34923 6.7952L9.34697 6.79408Z" fill="white"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_893_14770">
                      <rect width="12.8" height="12.2667" fill="white" transform="translate(0.866638 0.400024)"/>
                      </clipPath>
                      </defs>
                  </svg>
              </span>
              <span class='ba-title' v-text="t.website_builder"></span>
          </div>
          <div class='ba6-data-content ba-content ba-w-100'>
              <a v-if="w.show" v-for="w,i in websiteBuilderProgress" :key="i" class='ba-progress'>
                  <span class='ba-progress-title ba-text-capitalize' v-text="w.title"></span>
                  <progress
                    :class="{'ba-progress-bar': true, 'ba-limit-alert': w.max && w.value > w.max}"
                    :value='!w.max ? w.value : w.value > w.max ? w.max : w.value'
                    :max='!w.max ? null : w.max > w.value ? w.max : w.value'
                  ></progress>
                  <div class='ba-progress-details'>
                      <span class='ba-progress-data'>{{ w.value }} {{ t.label_of }} {{ !w.max ? t.label_unlimited : w.max }}</span>
                  </div>
                  <br>
              </a>
          </div>
        </div>
      </builderall-loader>
      <builderall-loader class="ba-w-100" :loading="loadingMbData">
        <div class="ba-card ba-h-100">
          <div class='ba6-card-top ba-flex ba-gp-1 ba-ai-center ba-w-100'>
              <span class="ba6-main-icon ba-bg-blue1">
                <builderall-icon code='email-marketing-5'></builderall-icon>
              </span>
              <span class='ba-title' v-text="t.title_mailingboss_v2"></span>
          </div>
          <div class='ba6-data-content ba-content ba-w-100'>
            <a v-if="m.show" v-for="m,i in mailingbossProgress" :key="i" class='ba-progress'>
                <span class='ba-progress-title ba-text-capitalize' v-text="m.title"></span>
                <progress
                  :class="{'ba-progress-bar': true, 'ba-limit-alert': m.max && m.value > m.max}"
                  :value='!m.max ? m.value : m.value > m.max ? m.max : m.value'
                  :max='!m.max ? null : m.max > m.value ? m.max : m.value'
                ></progress>
                <div class='ba-progress-details'>
                    <span class='ba-progress-data'>{{ m.value }} {{ t.label_of }} {{ !m.max ? t.label_unlimited : m.max }}</span>
                </div>
                <br>
              </a>
          </div>
        </div>
      </builderall-loader>
    </div>
    <div class="ba-card ba-w-100 ba-flex ba-gp-1 ba-f-column">
      <div class="ba-top">
        <span class="ba-title" v-text="t.storage_quotas"></span>
        <div v-if="!quotas.user_is_va" class="ba-box-items ba-flex ba-gp-1">
          <button class='ba-btn ba-sm ba-blue' @click="toggleModal('ba6-purchase-extra')">
              {{ t.purchase_extra }}
            <builderall-icon code='4970'/>
          </button>
        </div>
      </div>
      <div class='ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column'>
          <ba6-user-storage :routes="routes" :storage="quotas.storage" :t="t" />
      </div>
    </div>
    <div class="ba-card ba-w-100 ba-flex ba-gp-1 ba-f-column">
      <div class="ba-top">
        <span class="ba-title" v-text="t.label_my_domains"></span>
        <div v-if="!quotas.user_is_va" class="ba-box-items ba-flex ba-gp-1">
          <button class='ba-btn ba-sm ba-blue' @click="toggleModal('ba6-purchase-extra')">
              {{ t.purchase_extra }}
            <builderall-icon code='4970'/>
          </button>
        </div>
      </div>
      <builderall-loader class="ba-w-100" :loading="loadingConnections">
        <table class='ba6-connected-domains-table ba-table ba-md ba-w-100 ba-lines-all'>
            <thead>
                <tr>
                    <th></th>
                    <th class="ba-text-center">{{ t.label_in_use }}</th>
                    <th class="ba-text-center">{{ t.total }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ t.geral }}</td>
                    <td class="ba-text-center" v-text="!connectionsData || !connectionsData.domains_used ? 0 : connectionsData.domains_used"></td>
                    <td class="ba-text-center" v-text="!connectionsData || !connectionsData.domains_total ? 0 : connectionsData.domains_total"></td>
                </tr>
                <tr>
                    <td>WP pro & Woocomerce</td>
                    <td class="ba-text-center" v-text="!connectionsData || !connectionsData.wordpress_pro || !connectionsData.wordpress_pro.connected ? 0 : connectionsData.wordpress_pro.connected"></td>
                    <td class="ba-text-center" v-text="!connectionsData || !connectionsData.wordpress_pro || !connectionsData.wordpress_pro.available ? 0 : connectionsData.wordpress_pro.available"></td>
                </tr>
            </tbody>
        </table>
      </builderall-loader>
    </div>
    <ba6-modal modal-id="ba6-purchase-extra">
      <div class='ba-card ba-w-100 ba-no-shadow'>
        <div class='ba-top'>
            <div class="ba-flex ba-f-column">
              <span class='ba-title'>{{ t.purchase_extra }}</span>
              <span class='ba-subtitle'>{{ t.receipt_info1 }}</span>
              <span class='ba-subtitle'>{{ t.receipt_info2 }}.</span>
            </div>
            <div class='ba-box-items ba-flex ba-gp-1'>
              <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-purchase-extra')">
                  <builderall-icon code='64f7' />
              </button>
            </div>
        </div>
        <!-- Purchase Extra Modal -->
        <div class='ba-content ba-w-100 ba-flex ba-f-row ba-gp-2'>
          <div class="ba-flex ba-f-column ba-jc-center ba-ai-center ba-w-100 ba-gp-1">
            <div class='ba-box-items ba-flex ba-f-column ba-jc-center ba-ai-center'>
                <button class='ba-btn ba-rounded-size ba-rounded'>
                  <builderall-icon code='9762'/>
                </button>
                <h5 class="ba-montserrat-300">{{ t.extra }}</h5>
            </div>
            <div>
            <h1 class="ba-montserrat-700" v-text="'+' + quotas.storage.sell_storage_qtd + ' GB'"></h1>
            </div>
            <div class="ba-pd-2	ba-w-100 ba-flex ba-jc-center ba-ai-center">
            <button v-if="quotas.allowed_buy_storage" class='ba-btn ba-w-50 ba-md ba-green' @click="chooseBuyExtraStorage()">
                {{ t.label_buy_now }}
                <builderall-icon code='4970' />
            </button>
            <button v-else class='ba-btn ba-w-50 ba-md ba-green' disabled ba-tooltip-position='bottom' :ba-tooltip-title='t.pg_require_upgrade'>
                {{ t.label_buy_now }}
                <builderall-icon code='4970' />
            </button>
          </div>
          </div>
          <div class="ba-flex ba-f-column ba-jc-center ba-ai-center ba-w-100 ba-gp-1">
            <div class='ba-box-items ba-flex ba-f-column ba-jc-center ba-ai-center'>
                <button class='ba-btn ba-rounded-size ba-rounded'>
                  <builderall-icon code='7faf'/>
                </button>
                <h5 class="ba-montserrat-300">{{ t.extra }}</h5>
            </div>
            <div>
            <h1 class="ba-montserrat-700" v-text="'+' + quotas.storage.sell_domain_qtd + ' ' + t.dns_connection"></h1>
            </div>
            <div class="ba-pd-2	ba-w-100 ba-flex ba-jc-center ba-ai-center">
            <button v-if="quotas.allowed_buy_connections" class='ba-btn ba-w-50 ba-md ba-green' @click="chooseBuyExtraConnection()">
                {{ t.label_buy_now }}
                <builderall-icon code='4970' />
            </button>
              <button v-else class='ba-btn ba-w-50 ba-md ba-green' disabled ba-tooltip-position='bottom' :ba-tooltip-title='t.pg_require_upgrade'>
                {{ t.label_buy_now }}
                <builderall-icon code='4970' />
            </button>
          </div>
          </div>
        </div>
      </div>
    </ba6-modal>
    <!-- Buy Extra Storage Modal -->
    <ba6-modal modal-id="ba6-purchase-extra-gb">
      <div class='ba-card ba-w-100 ba-no-shadow'>
        <div class='ba-top'>
            <span class='ba-title'>{{ t.extra_storage }}</span>
            <div class='ba-box-items ba-flex ba-gp-1'>
              <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-purchase-extra-gb')">
                  <builderall-icon code='64f7' />
              </button>
            </div>
        </div>
        <builderall-loader class="ba-w-100" :loading="loadingExtraStoragePrice">
          <div v-if="quotas.allowed_buy_extra" class="ba-w-100 ba-flex ba-f-column ba-gp-2">
            <div class='ba-content ba-w-100 ba-flex ba-f-column ba-gp-1'>
              <span>{{ t.label_ext_storage }}</span>
              <input type='number' class='ba-input' placeholder='10,00' v-model="gbData.gb" :min="gbData.sum" :step="gbData.sum" @input="updatePriceExtraStorage()"/>
              <span v-text="gbData.value"></span>
            </div>
            <div class='ba-content ba-w-100 ba-flex ba-jc-fe ba-f-row ba-gp-2 ba-pd-t-1'>
              <button class='ba-btn ba-md ba-light' @click="toggleModal('ba6-purchase-extra-gb')">{{ t.button_cancelar }}</button>
              <button class='ba-btn ba-md ba-green' @click="buyExtraStorage()">
                {{ t.label_buy_now }}
                <builderall-icon code='4970' />
              </button>
            </div>
          </div>
          <div v-else class="ba-w-100 ba-flex ba-f-column ba-gp-2">
            <span v-if="quotas.is_website_agency" v-html="t.not_allowed_to_buy_extra_resources_wa"></span>
            <span v-else v-html="t.not_allowed_to_buy_extra_resources"></span>
            <div class='ba-content ba-w-100 ba-flex ba-jc-fe ba-f-row ba-gp-2 ba-pd-t-1'>
              <button class='ba-btn ba-md ba-light' @click="toggleModal('ba6-purchase-extra-gb')">{{ t.button_cancelar }}</button>
            </div>
          </div>
        </builderall-loader>
      </div>
    </ba6-modal>
    <!-- Buy Extra Connection Modal -->
    <ba6-modal modal-id="ba6-purchase-extra-connection">
      <div class='ba-card ba-w-100 ba-no-shadow'>
        <div class='ba-top'>
            <span class='ba-title'>{{ t.label_buy_ext_con_title }}</span>
            <div class='ba-box-items ba-flex ba-gp-1'>
              <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-purchase-extra-connection')">
                  <builderall-icon code='64f7' />
              </button>
            </div>
        </div>
        <builderall-loader class="ba-w-100" :loading="loadingExtraConnectionPrice">
          <div v-if="quotas.allowed_buy_extra" class="ba-w-100 ba-flex ba-f-column ba-gp-2">
            <div class='ba-content ba-w-100 ba-flex ba-f-column ba-gp-1'>
              <span>{{ t.label_ext_con }}</span>
              <input type='number' class='ba-input' placeholder='1,00' v-model="connectionData.con" :min="connectionData.sum" :step="connectionData.sum" @input="updatePriceExtraConnection()"/>
              <span v-text="connectionData.value"></span>
            </div>
            <div class='ba-content ba-w-100 ba-flex ba-jc-fe	 ba-f-row ba-gp-2 ba-pd-t-1'>
              <button class='ba-btn ba-md ba-light' @click="toggleModal('ba6-purchase-extra-connection')">{{ t.button_cancelar }}</button>
              <button class='ba-btn ba-md ba-green' @click="buyExtraConnection()">
                {{ t.label_buy_now }}
                <builderall-icon code='4970' />
              </button>
            </div>
          </div>
          <div v-else class="ba-w-100 ba-flex ba-f-column ba-gp-2">
            <span v-if="quotas.is_website_agency" v-html="t.not_allowed_to_buy_extra_resources_wa"></span>
            <span v-else v-html="t.not_allowed_to_buy_extra_resources"></span>
            <div class='ba-content ba-w-100 ba-flex ba-jc-fe	 ba-f-row ba-gp-2 ba-pd-t-1'>
              <button class='ba-btn ba-md ba-light' @click="toggleModal('ba6-purchase-extra-connection')">{{ t.button_cancelar }}</button>
            </div>
          </div>
        </builderall-loader>
      </div>
    </ba6-modal>
  </div>
  <div class="ba-grid ba-gp-1" v-else>
        <div class="ba-card ba6-plan-data">
      <div class="ba6-left-plan-data ba-flex ba-gp-1 ba-f-column ba-h-100">
        <div class="ba-grid ba-gp-1 ba-ai-start ba-h-50">
            <span class="ba6-info-subtitle" v-text="t.label_plan"></span>
            <span class="ba6-info-title" v-text="accountInfo.plan"></span>
            <!-- Plan resources -->
            <span class="ba6-info-subtitle" v-for="(resource, index) in bundleResources()" :key="index">{{ resource['limit'] }} {{ resourceTitle(resource['slug']) }}</span>
        </div>
        <div class="ba-flex ba-gp-1 ba-ai-end ba-h-50">
          <a href="https://checkout.builderall.com/plans" target="_blank" class="ba-btn ba-md ba-blue ba-w-100" v-text="t.change_my_plan"></a>
        </div>
      </div>
      <hr v-if="!hasErrorToGetMbDataFromDate || loadingMbDataFromLastPaymentDate" class='ba-hr-column'>
      <builderall-loader v-if="!hasErrorToGetMbDataFromDate || loadingMbDataFromLastPaymentDate" class="ba-w-100" :loading="loadingMbDataFromLastPaymentDate">
        <div class="ba-grid ba-gp-1 ba-pd-y-1">
          <div class="ba-flex ba-gp-1 ba-ai-center ba-jc-sb">
            <span class="ba6-info-subtitle" v-text="t.package_price"></span>
            <strong v-if="!!usageData && !!usageData.billing_amount && usageData.billing_amount.amount_charged && usageData.billing_amount.currency_charged" class="ba6-payment-amount">{{ `${usageData.billing_amount.currency_charged} ${usageData.billing_amount.amount_charged}`}} = {{ usageData.currency}} {{ usageData.billing_amount.amount }}</strong>
            <strong v-else class="ba6-payment-amount">{{ usageData.currency}} {{ parseFloat(usageData.billing_amount.amount).toFixed(2) || '0.00' }}</strong>
          </div>
          <span class="ba6-info-subtitle ba6-subtitle-tooltip">
            {{ t.usage }} <builderall-icon
                    ba-tooltip-position='bottom'
                    :ba-tooltip-title="t.displayed_usage_calculated_from + ' ' + usageData.last_payment"
                    ba-tooltip-color='dark'
                    code='help'
                  ></builderall-icon>
          </span>
          <div class="ba6-box-progress-amount" v-for="(resource, index) in bundleResources()" :key="index">
            <a class='ba-progress'>
                <span class='ba-progress-title' v-text="resourceTitle(resource['slug'])"></span>
                <progress
                  :class="{'ba-progress-bar': true, 'ba-limit-alert': showAlertLimit(resource)}"
                  :value="!resource['limit'] ? resource['usage'] : resource['usage'] > resource['limit'] ? resource['limit'] : resource['usage']"
                  :max="!resource['limit'] ? null : resource['limit'] > resource['usage'] ? resource['limit'] : resource['usage']"
                ></progress>
                <div class='ba-progress-details'>
                    <span class='ba-progress-data' v-text="getProgressBillingData(resource)"></span>
                </div>
            </a>
            <span class="ba6-info-amount" v-if="!resource.amount" v-text="t.label_included"></span>
            <span class="ba6-info-amount" v-else>{{ resource.currency }} {{ parseFloat(resource.amount).toFixed(2) }}</span>
          </div>
          <br>
          <hr class="ba-hr-row">
          <div class="ba-flex ba-gp-1 ba-ai-center ba-jc-sb">
            <div class="ba-grid">
              <span class="ba6-info-subtitle" v-text="t.estimated_bill"></span>
              <span class="ba6-payment-data">{{ t.next_payment_on }} {{ usageData.next_payment || accountInfo.user_data.pag_validade }}</span>
            </div>
            <span class="ba6-payment-total-amount">{{ usageData.currency}} {{ (parseFloat(usageData.billing_amount.amount) + parseFloat(usageData.amount)).toFixed(2) }}</span>
          </div>
        </div>
      </builderall-loader>
    </div>
  </div>
</template>

<script>
export default {
  name: "ba6-quotas",
  props: ['routes','quotas','t','accountInfo'],
  data() {
    return {
      connectionsData: [],
      loadingConnections: false,
      loadingMbData: false,
      loadingWbData: false,
      loadingMbDataFromLastPaymentDate: false,
      loadingExtraStoragePrice: false,
      loadingExtraConnectionPrice: false,
      hasErrorToGetMbDataFromDate: true,
      is_bundle: false,
      is_concessionaire: false,
      resources: [],
      bundle_resources: ["browser-notifications", "exit-popup",  "social-proof", "live-chat", "messenger-responder"],
      gbData: {
        price: null,
        currency: null,
        sum: null,
        gb: null,
        qtd: 1,
        value: null,
        min: 1
      },
      connectionData: {
        price: null,
        currency: null,
        sum: null,
        con : null,
        qtd: 1,
        value : null,
        min: 1
      },
      mbData: [],
      websiteBuilderData: [],
      usageData: {
        currency: 'USD',
        amount: 0,
        resources: [
          {
              slug: 'mailingboss-subscribers',
              limit: 0,
              usage: 0,
              plan_limit: 0,
              extra_limit: 0,
              amount: 0,
              currency: 'USD'
          },
          {
              slug: 'mailingboss-emails-sent',
              limit: 0,
              usage: 0,
              plan_limit: 0,
              extra_limit: 0,
              amount: 0,
              currency: 'USD'
          },
          {
              slug: 'professional-emails-accounts',
              limit: 0,
              usage: 0,
              plan_limit: 0,
              extra_limit: 0,
              amount: 0,
              currency: 'USD'
          },
          {
              slug: "super-checkout-fee",
              usage: 0,
              percentage: 0,
              amount: 0,
              currency: "USD"
          }
        ],
        last_payment: '0000-00-00'
      },
      websiteBuilderProgress: [
        {
          title: this.t.published_site,
          value: 0,
          max: null,
          show: true
        },
        {
          title: this.t.unpublished_site,
          value: 0,
          max: null,
          show: true
        },
        {
          title: this.t.dns_domain_connected_label,
          value: 0,
          max: null,
          show: true
        },
        {
          title: this.t.connected_subdomain,
          value: 0,
          max: null,
          show: true
        },
      ],
      mailingbossProgress: [
        {
          title: this.t.subscribers_plan,
          value: 0,
          max: null,
          show: false
        },
        {
          title: this.t.subscribers_list,
          value: 0,
          max: null,
          show: true
        },
        {
          title: this.t.email_sent,
          value: 0,
          max: null,
          show: false
        },
        {
          title: this.t.workflows,
          value: 0,
          max: null,
          show: true
        },
      ]
    }
  },
  mounted(){
    if (!this.is_bundle) {
      this.getConnectionsData()
      this.getMailingbossData()
      this.getWebsiteBuilderStatistics()
    }
    this.getBillingInfo()
  },
  created(){
    this.is_bundle         = this.accountInfo.is_bundle
    this.is_concessionaire = this.accountInfo.user_data.hasOwnProperty('is_franchise_builderall') && this.accountInfo.user_data.is_franchise_builderall == '1'
  },
  methods: {
    getProgressBillingData(data){
      return `${data.usage} ${this.t.label_of} ${data.limit == 'UNLIMITED' ? this.t.label_unlimited : data.limit} (${this.getPercentage(data)})`;
    },
    showAlertLimit(data){
      return data.limit && data.usage > data.limit;
    },
    getPercentage(data){
      if(!data.usage || !data.limit || data.limit == 'UNLIMITED'){
        return '0%';
      } else {
        let usage = parseFloat(data.usage).toFixed(2);
        return ((usage * 100) / data.limit).toFixed(2) + '%';
      }
    },
    getBillingInfo(){
      this.loadingMbDataFromLastPaymentDate = true;

      const headers = {
        Accept: 'application/json',
        Authorization: this.quotas.user_token
      };

      // mocked data to local
      // this.usageData = JSON.parse('{"currency":"USD","amount":283.4,"resources":[{"slug":"mailingboss-subscribers","limit":"UNLIMITED","usage":0,"plan_limit":25000,"extra_limit":0,"amount":0,"currency":"USD"},{"slug":"mailingboss-emails-sent","limit":5,"usage":0,"plan_limit":600000,"extra_limit":0,"amount":0,"currency":"USD"},{"slug":"professional-emails-accounts","limit":20,"usage":1,"plan_limit":20,"extra_limit":0,"amount":0,"currency":"USD"},{"slug":"super-checkout-fee","usage":21800,"percentage":1.3,"amount":283.4,"currency":"USD"}],"last_payment":"2024-07-27","billing_amount":{"currency":"EUR","amount":"520.00","currency_charged":null,"amount_charged":null}}');
      // this.hasErrorToGetMbDataFromDate = false;
      // this.organizeUsageData();
      // this.loadingMbDataFromLastPaymentDate = false

      // real data to sandbox, staging and production
      fetch(this.quotas.orchestrator_route+'/api/v1/users/quotas/billing-info', {
        method: 'GET',
        headers: headers
      })
        .then(response => response.json())
        .then(result => {
            if(Object.keys(result.data).length > 0){
              if(!result.data.hide_pannel){
                this.usageData = result.data;
                this.hasErrorToGetMbDataFromDate = false;
                this.resources = this.usageData.resources;
                this.organizeUsageData();
              }
            }
        })
        .catch(error => {
          console.log('getBillingInfo data error', error);
        })
        .finally(f => this.loadingMbDataFromLastPaymentDate = false)
    },
    organizeUsageData(){
      this.mailingbossProgress[0]['value'] = this.usageData.resources[0]['usage'];
      this.mailingbossProgress[0]['max']   = this.usageData.resources[0]['limit'];
      this.mailingbossProgress[0]['show']  = true;
      this.mailingbossProgress[2]['value'] = this.usageData.resources[1]['usage'];
      this.mailingbossProgress[2]['max']   = this.usageData.resources[1]['limit'];
      this.mailingbossProgress[2]['show']  = true;
    },
    getWebsiteBuilderStatistics(){
      this.loadingWbData = true;

      const headers = {
        Accept: 'application/json',
        Authorization: this.quotas.user_token
      };

      fetch(this.quotas.orchestrator_route+'/api/v1/office/dashboard-data/website-builder', {
        method: 'GET',
        headers: headers
      })
        .then(response => response.json())
        .then(result => {
            if(Object.keys(result.data).length > 0){
              this.websiteBuilderData = result.data;
              this.organizeWebsiteBuilderData();
            }
        })
        .catch(error => {
          console.error('getWebsiteBuilderStatistics data error', error);
        })
        .finally(f => this.loadingWbData = false)
    },
    organizeWebsiteBuilderData(){
      this.websiteBuilderProgress[0]['value'] = this.websiteBuilderData.published_websites;
      this.websiteBuilderProgress[0]['max']   = !this.websiteBuilderData.account_limits || !this.websiteBuilderData.account_limits.published_websites ? null : this.websiteBuilderData.account_limits.published_websites;
      this.websiteBuilderProgress[1]['value'] = this.websiteBuilderData.unpublished_websites;
      this.websiteBuilderProgress[1]['max']   = !this.websiteBuilderData.account_limits || !this.websiteBuilderData.account_limits.unpublished_websites ? null : this.websiteBuilderData.account_limits.unpublished_websites;
      this.websiteBuilderProgress[2]['value'] = this.websiteBuilderData.connected_domains;
      this.websiteBuilderProgress[2]['max']   = !this.websiteBuilderData.account_limits || !this.websiteBuilderData.account_limits.connected_domains ? null : this.websiteBuilderData.account_limits.connected_domains;
      this.websiteBuilderProgress[3]['value'] = this.websiteBuilderData.connected_subdomains;
      this.websiteBuilderProgress[3]['max']   = !this.websiteBuilderData.account_limits || !this.websiteBuilderData.account_limits.connected_subdomains ? null : this.websiteBuilderData.account_limits.connected_subdomains;
    },
    getMailingbossData(){
      this.loadingMbData = true;
      const headers = {
        Accept: 'application/json',
        Authorization: this.quotas.user_token
      };

      fetch(this.quotas.orchestrator_route+'/api/v1/office/dashboard-data/mailingboss-5', {
        method: 'GET',
        headers: headers
      })
        .then(response => response.json())
        .then(result => {
            if(result.success && Object.keys(result.data).length > 0){
              this.mbData = result.data;
              this.organizeMailingbossData();
            }
        })
        .catch(error => {
            console.error('getMbStatistics data error', error);
        })
        .finally(f => this.loadingMbData = false)
    },
    organizeMailingbossData(){
      this.mailingbossProgress[1]['value'] = this.mbData.lists;
      this.mailingbossProgress[1]['max']   = null;
      this.mailingbossProgress[3]['value'] = this.mbData.workflows;
      this.mailingbossProgress[3]['max']   = null;
    },
    toggleModal(data){
      $(`#${data}`).toggle('show');
    },
    getConnectionsData(){
      this.loadingConnections = true;

      axios
        .get(this.routes.rota_office_request_connetions_data)
        .then(response => {
          this.connectionsData = response.data;
        })
        .catch(error => {
          console.error('Error to get connections data', error);
        })
        .finally(() => {
          this.loadingConnections = false;
        })
    },
    // Extra Connection
    chooseBuyExtraConnection(){
      this.toggleModal('ba6-purchase-extra');
      this.toggleModal('ba6-purchase-extra-connection');
      this.getExtraConnectionPrices();
    },
    resourceIsActive (idx) {
      return Array.isArray(this.usageData.resources) && idx in this.usageData.resources;
    },
    getExtraConnectionPrices(){
      this.loadingExtraConnectionPrice = true

      axios
        .get(this.routes.rota_office_extra_domain_price)
        .then((response) => {
            if(response.data.price)
            {
              this.connectionData.price    = response.data.price;
              this.connectionData.currency = response.data.currency;
              this.connectionData.sum      = response.data.package;
              this.connectionData.con      = this.connectionData.sum;
              this.connectionData.min      = this.connectionData.sum;

              this.updatePriceExtraConnection();
            }
        })
        .catch((error) => {
          console.error('Error to get extra connection price', error);
        })
        .finally(() => {
          this.loadingExtraConnectionPrice = false;
        });
    },
    updatePriceExtraConnection(){
      if(this.connectionData.con < this.connectionData.min)
      {
        this.connectionData.con = this.connectionData.min;
      }

      setInterval(() => {
        this.connectionData.qtd   = this.connectionData.con / this.connectionData.sum;
        this.connectionData.value = this.t.label_price + ': ' + this.connectionData.currency + ' ' + (this.connectionData.qtd * this.connectionData.price).toFixed(2) + ' / ' + this.t.month;

        if(this.connectionData.con % this.connectionData.sum != 0){
          let m = Math.round(this.connectionData.qtd, 1) > 0 ? Math.round(this.connectionData.qtd, 1) : 1;
          this.connectionData.con = this.connectionData.sum * m;
        }
      }, 1000);
    },
    buyExtraConnection(){
      let params = new URLSearchParams({
        extraConnection: 1,
        extraConnectionQtd: this.connectionData.qtd
      });

      window.open(`${__env.checkout.url}/payment/${__env.checkout.slugs.extraConnection}?${params.toString()}`,'_TOP');
    },
    // Extra Storage
    chooseBuyExtraStorage(){
      this.toggleModal('ba6-purchase-extra');
      this.toggleModal('ba6-purchase-extra-gb');
      this.getExtraStoragePrices();
    },
    getExtraStoragePrices(){
      this.loadingExtraStoragePrice = true

      axios
        .get(this.routes.rota_office_extra_storage_price)
        .then((response) => {
            if(response.data.price)
            {
              this.gbData.price    = response.data.price;
              this.gbData.currency = response.data.currency;
              this.gbData.sum      = response.data.package;
              this.gbData.gb       = this.gbData.sum;
              this.gbData.min      = this.gbData.sum;

              this.updatePriceExtraStorage();
            }
        })
        .catch((error) => {
          console.error('Error to get extra storage price', error);
        })
        .finally(() => {
          this.loadingExtraStoragePrice = false;
        });
    },
    updatePriceExtraStorage(){
      if(this.gbData.gb < this.gbData.min)
      {
        this.gbData.gb = this.gbData.min;
      }


      setInterval(() => {
        this.gbData.qtd      = this.gbData.gb / this.gbData.sum;
        this.gbData.value    = this.t.label_price + ': ' + this.gbData.currency + ' ' + (this.gbData.qtd * this.gbData.price).toFixed(2) + '/' + this.t.month;

        if(this.gbData.gb % this.gbData.sum != 0)
        {
          let m = Math.round(this.gbData.qtd, 1) > 0 ? Math.round(this.gbData.qtd, 1) : 1;
          this.gbData.gb = this.gbData.sum * m;
        }
      }, 1000);
    },
    buyExtraStorage(){
      let params = new URLSearchParams({
          extraStorage: 1,
          extraStorageQtd: this.gbData.qtd
      });

      window.open(`${__env.checkout.url}/payment/${__env.checkout.slugs.extraStorage}?${params.toString()}`, '_TOP');
    },
    getResourceBySlug(slug) {
      return this.resources.find(resource => resource.slug === slug);
    },
    bundleResources() {
      return this.bundle_resources
        .map((resource) => this.getResourceBySlug(resource))
        .filter((resource) => !!resource);
    },
    resourceTitle(slug) {
      return {
        "browser-notifications": this.t.browser_notifications_subscribers,
        "exit-popup": this.t.exit_intent_popup_impressions,
        "social-proof": this.t.social_proof_impressions,
        "live-chat": this.t.website_live_chat,
        "messenger-responder": this.t.meta_comment_replies,
      }[slug] || '';
    },
  }
}
</script>


<style scoped lang="scss">
  .ba-rounded-size{
    width: 88px;
    height: 87px;
    cursor: default;
  }
  .ba6-plan-data{
    display: grid;
    grid-template-columns: 1fr auto 1.4fr;
    gap: 32px;
    .ba6-left-plan-data{
      grid-template-rows: auto auto auto 1fr auto;
    }
    .ba6-info-title,
    .ba6-info-subtitle{
      color: #2A3C51;
      font-weight: 700;
    }
    .ba6-info-amount{
      font-size: 12px;
      margin-top: 16px;
      color: #2A3C51;
      font-weight: 700;
    }
    .ba6-info-title{
      font-size: 24px;
    }
    .ba6-info-subtitle{
      font-size: 16px;
    }
    .ba6-box-progress-amount{
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 8px;
    }
    .ba6-subtitle-tooltip{
      display: flex;
      align-items: center;
      gap: 8px;
      builderall-icon{
        --builderall-icon-size: 14px;
        --builderall-icon-color: #0072E1;
      }
    }
    .ba6-payment-data{
      font-size: 12px;
      color: #B4C4D7;
      font-weight: 500;
    }
    .ba6-payment-amount{
      color: #4D5D71;
      font-size: 16px;
    }
    .ba6-payment-total-amount{
      color: #4D5D71;
      font-size: 32px;
      font-weight: 600;
    }
  }
  .ba6-card-top{
    border-bottom: 1px solid #B4C4D7;
    padding-bottom: 8px;
  }
  .ba6-data-content{
    width: 100%;
    display: grid;
    gap: 12px;
    padding-bottom: 16px;
  }
  .ba6-main-icon{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    builderall-icon{
      --builderall-icon-size: 20px;
      --builderall-icon-color: #fff;
    }
  }
  .quotas-two-elements{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  builderall-icon{
    --builderall-icon-size: 51px;
    --builderall-icon-color: #0072E1;
  }
  .ba6-us-main-horizontal-line{
    background-color: #C4D1E0;
    width: 100%;
    height: 1px;
  }
  .ba6-connected-domains-table{
    thead{
      tr{
        th{
          width: 33.33%;
        }
      }
    }
    tbody{
      tr{
        td:not(:first-child){
          color: #8D9EB5;
          font-weight: 500;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/routes/Quotas.vue